$(() => {

  //Bundle PDP - Add to Cart
  $(document).on('click', '.bundle-ajax-submit', function(e) {
    e.preventDefault();
    let $addToCartBtn = $(this);
    let bundleID = $addToCartBtn.attr('data-bundle-product-id');
    let masterHandle = $addToCartBtn.attr('data-bundle-master-handle');
    let bundleTitle = $addToCartBtn.attr('data-bundle-master-title');
    let bundleDiscount = parseInt($addToCartBtn.attr('data-bundle-discount'))/100;
    $.fn.reverse = [].reverse;

    //build ajax atc data
    let itemsArray = [];
    let bundleKeyProp = [];
    $('.bundle-group__swatch.active').each(function() {
      bundleKeyProp.push(parseInt($(this).attr('data-variant-id')));
    });
    $('.bundle-group__swatch.active').reverse().each(function() {
      itemsArray.push(
        {
          quantity: 1,
          id: parseInt($(this).attr('data-variant-id')),
          properties: {
            '_bundle_key': bundleKeyProp.join('|'),
            '_bundle_master_id': bundleID,
            '_bundle_master_handle': masterHandle,
            '_bundle_master_title': bundleTitle,
            '_bundle_discount': bundleDiscount
          }
        }
      );
    });

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { items: itemsArray },
      beforeSend: function() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function(itemData) {
        document.dispatchEvent(new CustomEvent("cart:item:added", { detail:
          {
            'response': itemData,
            'items_added': itemsArray
          }
        }));

        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        window.setTimeout(function(){
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
        }, 1000);

        refreshCart(); //function lives in global.js
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();
        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
        $addToCartBtn.after(warning);
        console.error(warning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text(Shopify.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
      }
    });

    return false;
  });

  //Bundle PDP - Option Selection
  $(document).on('click', '.bundle-group__swatch', function() {
     //change group image if swatch not already selected
    if(!$(this).hasClass('active')){
      let featuredImage = $(this).attr('data-featured-image');
      let imageTarget = $(this).attr('data-image-target');
      $(imageTarget).parent().fadeTo( 200 , 0, function() {
        let img = new Image();
        img.src = featuredImage;
        img.onload = function() {
          $(imageTarget).attr('src',img.src);
          $(imageTarget).parent().fadeTo( 100 , 1);
        }
      });
    }
    //change active class
    $(this).parent().find('.bundle-group__swatch').removeClass('active');
    $(this).addClass('active');
    //change swatch name
    let swatchName = $(this).attr('data-swatch-name');
    let labelTarget = $(this).attr('data-label-target');
    $(labelTarget).text(swatchName);

    // trigger view item event for GA4 datalayer.
    document.dispatchEvent(new CustomEvent("product:view", { detail:
      {
        'trigger': $(this)[0]
      }
    }));

    //enable atc button if all option groups have a selection
    let activeCount = 0;
    $(".bundle-group").each(function() {
      if($(this).find('.bundle-group__swatch.active').length == 1) activeCount++;
    });
    if($(".bundle-group").length == activeCount) { //all groups have a selection
      let atcEnabledText = $('.bundle-ajax-submit').attr('data-atc-enabled-text');
      $('.bundle-ajax-submit').find('.text').text(atcEnabledText);
      $('.bundle-ajax-submit').removeClass('disabled');
    }
  });

  //Bundle PDP - Swatch Name Change with MouseOver
  $(document).on('mouseover', '.bundle-group__swatch', function() {
    //change swatch name
    let swatchName = $(this).attr('data-swatch-name');
    let labelTarget = $(this).attr('data-label-target');
    $(labelTarget).text(swatchName);
  });

  //Bundle PDP - Swatch Name Change with MouseOut
  $(document).on('mouseout', '.bundle-group__swatch', function() {
    //change swatch name
    let selectedSwatch = $(this).parents('.bundle-group__options').find('.bundle-group__swatch.active');
    if(!!selectedSwatch.length){
      let swatchName = selectedSwatch.attr('data-swatch-name');
      let labelTarget = $(this).attr('data-label-target');
      $(labelTarget).text(swatchName);
    }
  });

});
